import React, { useContext } from 'react';
import DotsVerticalIcon from 'mdi-react/DotsVerticalIcon';
import PanelHeader from '@prisjakt/ui-panel-header';
import { AppContext } from '@prisjakt/ui-app-context';
import { useDispatch } from 'react-redux';
import PriceListHeaderTitle from './price-list-header-title';
import PriceListDisclaimer from './price-list-disclaimer';
import PriceFilters from '../price-filters/price-filters';
import GroupOptions from '../group-options';
import SortOptions from '../../sort-options';
import { priceShippingSort, priceGrouping } from '../../../actions/product';
import { Price, User } from '../../../../../types';
import * as S from '../styles';
import { SortOption } from '../../sort-options/types';
import MissingShop from '../../missing-shop';
import { IPriceFilter } from '../types';
import { GroupOption } from '../group-options/types';
import ViewportContext from '../../../../../components/viewport/context';
import QuickPriceFilters from '../quick-price-filters/quick-price-filters';

const PriceListHeader: React.FC<IPriceListHeaderProps> = props => {
  const {
    sortedPrices,
    me,
    quickFilters,
    currentSort,
    currentGrouping,
    handlePriceFilterCheckboxChange,
    priceFilters,
  } = props;

  const { t } = useContext(AppContext);
  const dispatch = useDispatch();
  const { isMobile } = useContext(ViewportContext);

  return (
    <S.Header>
      {props.splitList && (
        <S.StyledHeader>
          <PriceListHeaderTitle sortedPrices={sortedPrices} me={me} />
        </S.StyledHeader>
      )}
      <PanelHeader
        title={
          !props.splitList && (
            <>
              <S.OnlyDesktop data-test="PricePanelHeader">
                {t('product', 'prices.title')}
                <S.TitleCount>({sortedPrices?.length || 0})</S.TitleCount>
                {me?.analyticsAccess?.stores && <MissingShop />}
              </S.OnlyDesktop>
            </>
          )
        }
        leftComponent={
          props.splitList && (
            <>
              <GroupOptions
                compact={isMobile}
                setCurrentGrouping={group => dispatch(priceGrouping(group))}
                currentGrouping={currentGrouping}
              />

              <PriceListDisclaimer />
            </>
          )
        }
        divider="none"
      >
        {sortedPrices?.length ? (
          <div style={props.splitList ? undefined : { flex: '1 1 auto' }}>
            <SortOptions
              prices={sortedPrices as Price[]}
              compact={isMobile && Boolean(quickFilters.length)}
              setCurrentSort={sort => dispatch(priceShippingSort(sort))}
              currentSort={currentSort}
            />
          </div>
        ) : null}

        <QuickPriceFilters
          priceFilters={quickFilters}
          onFilterChanged={handlePriceFilterCheckboxChange}
        />

        <S.PriceFilter
          title={
            <>
              <S.OnlyMobile>
                <DotsVerticalIcon size={20} />{' '}
              </S.OnlyMobile>
              <S.TabletDesktop>
                {t('product', 'prices.more-filters')}{' '}
              </S.TabletDesktop>
            </>
          }
          type="custom-content-type"
          headerPosition="right"
          ariaLabel={t('product', 'prices.more-filters')}
          data-test="PriceFilters"
        >
          <PriceFilters
            priceFilters={priceFilters}
            onFilterChanged={handlePriceFilterCheckboxChange}
          />
        </S.PriceFilter>
      </PanelHeader>
    </S.Header>
  );
};

interface IPriceListHeaderProps {
  sortedPrices: Price[] | null | undefined;
  me: User;
  quickFilters: IPriceFilter[];
  currentSort: SortOption;
  currentGrouping: GroupOption;
  handlePriceFilterCheckboxChange: (e: any) => void;
  priceFilters: IPriceFilter[];
  splitList: boolean;
}

export default PriceListHeader;
